import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const userIconDark = svgToTinyDataUri(
  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <!-- Outer circle (head outline) -->
  <circle cx="12" cy="12" r="10" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <!-- Inner circle (head) -->
  <circle cx="12" cy="9" r="4" stroke="#222222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <!-- Body (shoulders arc) -->
  <path d="M5.97333 19.2855C6.46991 17.1786 8.31112 14 12.8493 14C17.27 14 19.1315 17.0161 19.6839 19.1198" stroke="#222222" stroke-width="2"/>
</svg>`
);
